<template>
  <v-dialog
    v-if="loaded"
    v-model="showDialog"
    persistent
    max-width="940px"
    content-class="print-or-save-invoices-dialog"
  >
    <v-card class="print-or-save-dialog-container">
      <component :is="currentStepComponent" />
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { computed, onBeforeMount, onMounted, onUnmounted, ref, provide } from 'vue'
import ImportExpedientsUploaderComponent
  from '@/views/Expedients/components/ImportExpedientsDialog/components/ImportExpedientsUploaderComponent.vue'
import ImportExpedientsLoadingComponent
  from '@/views/Expedients/components/ImportExpedientsDialog/components/ImportExpedientsLoadingComponent.vue'
import ImportExpedientsSummaryComponent
  from '@/views/Expedients/components/ImportExpedientsDialog/components/ImportExpedientsSummaryComponent.vue'
import {
  useImportExpedientsProcessStore
} from '@/views/Expedients/components/ImportExpedientsDialog/stores/useImportExpedientsProcessStore'

defineProps({
  showDialog: {
    type: Boolean,
    required: true
  }
})

const STEPS_COMPONENTS = [
  ImportExpedientsUploaderComponent,
  ImportExpedientsLoadingComponent,
  ImportExpedientsSummaryComponent
]

const loaded = ref<boolean>(false)
const step = ref<number>(0)
const importExpedientsProcessStore = useImportExpedientsProcessStore()

const currentStepComponent = computed(() => STEPS_COMPONENTS[step.value])

const emit = defineEmits(['closeDialog'])
provide('closeDialog', () => emit(
  'closeDialog',
  importExpedientsProcessStore?.importSummary?.successCount ?? 0
))
provide('nextStep', () => step.value++)
provide('prevStep', () => step.value--)
provide('resetStep', () => step.value = 0)

function blockAppPointerEvents() {
  const app = document.querySelector('.v-application')
  const dialog = document.querySelector('.v-dialog__content.v-dialog__content--active')
  if (app && dialog) {
    app.classList.add('print-or-save-invoice-dialog')
    dialog.classList.add('print-or-save-invoice-dialog')
  }
}

function unblockAppPointerEvents() {
  const app = document.querySelector('.v-application')
  app!.classList.remove('print-or-save-invoice-dialog')
}

onBeforeMount(() => loaded.value = true)
onMounted(() => {
  importExpedientsProcessStore.init()
  blockAppPointerEvents()
})
onUnmounted(() => {
  importExpedientsProcessStore.finish()
  unblockAppPointerEvents()
})
</script>

<style lang="scss" scoped>
.print-or-save-dialog-container {
  display: flex;
  flex-direction: column;
  padding: 20px;

  .wizard-container {
    @include flex($justify-content: space-between);
    padding: 0;
  }

  .actions-footer {
    padding: 0;
    margin-top: 20px;
  }
}

</style>

<style lang="scss">
.v-application.print-or-save-invoice-dialog {
  pointer-events: none;
}

.v-dialog__content.v-dialog__content--active.print-or-save-invoice-dialog {
  background-color: $dialog-background-color;
}
</style>

